const messages: any = {
  'http.status.0.title': 'Erro',
  'http.status.0.message': 'Não foi possível fazer uma requisição a API!',
  'http.status.401.title': 'Sem autorização!',
  'http.status.401.message': 'Sessão expirada ou acesso não autorizado.',
  'http.status.403': 'Você não tem permissão para efetuar a ação',
  'http.status.404': 'Página não encontrada.',
  'http.status.405': 'Operação não suportada',
  'http.status.500': 'Erro interno no servidor, entre em contato com o suporte.',
  'http.status.undefined': 'Não foi possível se comunicar com os servidores.',
  'erro.generico': 'Erro não esperado aconteceu. Entre em contato com o suporte.',
  'erro.atencao': 'Atenção',
  'erro.sessao.expirada.titulo': 'Sessão Expirada',
  'erro.arquivo.grande.titulo': 'Arquivo Muito Grande',
  'erro.arquivo.grande': 'O arquivo submetido ultrapassa o limite permitido.',
  'dialogo.excluir.titulo': 'Excluir Usuário',
  'dialogo.excluir.mensagem': 'Tem certeza que deseja excluir?',
  'dialogo.sucesso': 'Sucesso!',
  'auth.erro.login': 'Erro ao fazer login',
  'auth.erro.alterar.senha': 'Erro ao alterar senha',
  'auth.erro.redefinir.senha': 'Erro ao redefinir a senha',
  'auth.sucesso.senha.alterada': 'Senha alterada com sucesso!',
  'guard.erro.permissao': 'Você não tem permissão para acessar essa rota',
  'usuario.erro.consultar': 'Erro ao consultar Usuário',
  'usuario.erro.listar': 'Erro ao listar Usuários',
  'usuario.erro.salvar': 'Erro ao salvar Usuário',
  'usuario.erro.editar': 'Erro ao editar Usuário',
  'usuario.erro.excluir': 'Erro ao excluir Usuário',
  'usuario.erro.buscar': 'Erro ao buscar dados',
  'usuario.erro.perfil': 'Erro ao buscar informações do usuário',
  'usuario.sucesso.salvo': 'Usuário salvo com sucesso!',
  'usuario.sucesso.editado': 'Usuário editado com sucesso!',
  'usuario.sucesso.excluido': 'Usuário excluído com sucesso!',
  'usuario.sucesso.perfil.recarregado': 'Informações recarregadas com sucesso!',
  'usuario.label.nome': 'Nome:',
  'usuario.label.celular': 'Celular:',
  'usuario.label.email': 'Email:',
  'usuario.label.matricula': 'Matrícula:',
  'usuario.tabela.id': 'ID',
  'usuario.tabela.usuario': 'Usuário',
  'usuario.tabela.nome': 'Nome',
  'usuario.tabela.perfil': 'Perfil',
  'usuario.tabela.email': 'Email',
  'empresa.erro.listar': 'Erro ao listar Empresa',
  'empresa.erro.consultar': 'Erro ao consultar Empresa',
  'empresa.erro.editar': 'Erro ao editar Empresa',
  'empresa.erro.salvar': 'Erro ao salvar Empresa',
  'empresa.erro.excluir': 'Erro ao excluir Empresa',
  'empresa.sucesso.editada': 'Empresa editada com sucesso!',
  'empresa.sucesso.salva': 'Empresa salva com sucesso!',
  'empresa.sucesso.excluida': 'Empresa excluída com sucesso!',
  'empresa.dialogo.excluir.titulo': 'Excluir Empresa',
  'empresa.tabela.id': 'ID',
  'empresa.tabela.razao.social': 'Razão Social',
  'empresa.tabela.cnpj': 'CNPJ',
  'empresa.tabela.nome.fantasia': 'Nome Fantasia',
  'cargo.erro.listar': 'Erro ao listar Cargos',
  'cargo.erro.consultar': 'Erro ao consultar Cargo para editar',
  'cargo.erro.editar': 'Erro ao editar Cargo',
  'cargo.erro.salvar': 'Erro ao salvar Cargo',
  'cargo.erro.excluir': 'Erro ao excluir Cargo',
  'cargo.sucesso.editado': 'Cargo editado com sucesso!',
  'cargo.sucesso.salvo': 'Cargo salvo com sucesso!',
  'cargo.sucesso.excluido': 'Cargo excluído com sucesso!',
  'cargo.dialogo.excluir.titulo': 'Excluir Cargo',
  'cargo.tabela.id': 'ID',
  'cargo.tabela.nome': 'Nome',
  'colaborador.erro.listar': 'Erro ao listar Colaboradores',
  'colaborador.erro.consultar': 'Erro ao consultar Colaborador',
  'colaborador.erro.consultar.editar': 'Erro ao consultar Colaborador para editar',
  'colaborador.erro.editar': 'Erro ao editar Colaborador',
  'colaborador.erro.salvar': 'Erro ao salvar Colaborador',
  'colaborador.erro.excluir': 'Erro ao excluir Colaborador',
  'colaborador.sucesso.editado': 'Colaborador editado com sucesso!',
  'colaborador.sucesso.salvo': 'Colaborador salvo com sucesso!',
  'colaborador.sucesso.excluido': 'Colaborador excluído com sucesso!',
  'colaborador.dialogo.excluir.titulo': 'Excluir Colaborador',
  'colaborador.tabela.id': 'ID',
  'colaborador.tabela.nome': 'Nome',
  'colaborador.tabela.cargo': 'Cargo',
  'colaborador.tabela.tipo': 'Tipo',
  'colaborador.tabela.empresas': 'Empresa(s)',
  'perfil.erro.listar': 'Erro ao listar Perfis',
  'perfil.erro.listar.permissoes': 'Erro ao listar Permissões',
  'perfil.erro.editar': 'Erro ao editar Perfil',
  'perfil.erro.salvar': 'Erro ao salvar Perfil',
  'perfil.erro.excluir': 'Erro ao excluir Perfil',
  'perfil.sucesso.editado': 'Perfil editado com sucesso!',
  'perfil.sucesso.salvo': 'Perfil salvo com sucesso!',
  'perfil.sucesso.excluido': 'Perfil excluído com sucesso!',
  'perfil.dialogo.excluir.titulo': 'Excluir Perfil',
  'perfil.tabela.id': 'ID',
  'perfil.tabela.nome': 'Nome',
  'apr.erro.listar': 'Erro ao listar APRs',
  'apr.erro.consultar': 'Erro ao consultar APR',
  'apr.erro.editar': 'Erro ao editar APR',
  'apr.erro.salvar': 'Erro ao salvar APR',
  'apr.erro.excluir': 'Erro ao excluir APR',
  'apr.sucesso.editada': 'APR editada com sucesso!',
  'apr.sucesso.salva': 'APR salva com sucesso!',
  'apr.sucesso.excluida': 'APR excluída com sucesso!',
  'apr.dialogo.excluir.titulo': 'Excluir APR',
  'apr.tabela.id': 'ID',
  'apr.tabela.codigo': 'Código',
  'apr.tabela.revisao': 'Revisão',
  'apr.tabela.status': 'Status',
  'apr.tabela.atividade': 'Atividade',
  'apr.tabela.data.validade': 'Data de validade',
  'apr.dialogo.historico.titulo': 'Histórico de APR',
  'pt.erro.listar': 'Erro ao listar Relatórios de Atividade',
  'pt.erro.consultar': 'Erro ao consultar Relatório de Atividade',
  'pt.erro.editar': 'Erro ao editar Relatório de Atividade',
  'pt.erro.salvar': 'Erro ao salvar Relatório de Atividade',
  'pt.erro.excluir': 'Erro ao excluir Relatório de Atividade',
  'pt.erro.gerar.relatorio': 'Erro ao gerar relatório',
  'pt.erro.carregar.detalhamento': 'Erro ao carregar detalhamento da PT',
  'pt.sucesso.editado': 'Relatório de Atividade editado com sucesso!',
  'pt.sucesso.salvo': 'Relatório de Atividade salvo com sucesso!',
  'pt.sucesso.excluido': 'Relatório de Atividade excluído com sucesso!',
  'pt.dialogo.excluir.titulo': 'Excluir Relatório de Atividade',
  'pt.tabela.id': 'ID',
  'pt.tabela.emitente': 'Emitente',
  'pt.tabela.codigo': 'Código',
  'pt.tabela.data.emissao': 'Data de emissão',
  'pt.tabela.status': 'Status',
  'pt.tabela.local': 'Local',
  'pt.status.emitida': 'Emitida',
  'pt.status.pendente': 'Pendente',
  'pt.status.cancelada': 'Cancelada',
  'pt.relatorio.tipo.manutencao.corretiva': 'Manutenção Corretiva',
  'pt.relatorio.tipo.manutencao.preventiva': 'Manutenção Preventiva',
  'pt.relatorio.tipo.comissionamento': 'Comissionamento',
  'pt.relatorio.tipo.instalacao': 'Instalação',
  'pt.relatorio.tipo.desinstalacao': 'Desinstalação',
  'pt.relatorio.tipo.levantamento': 'Levantamento',
  'pt.relatorio.categoria.servico': 'Serviço',
  'pt.relatorio.categoria.impedimento': 'Impedimento',
  'pt.relatorio.categoria.deslocamento': 'Deslocamento',
  'pt.relatorio.sim': 'Sim',
  'pt.relatorio.nao': 'Não',
  'pt.relatorio.gerando': 'Gerando relatório, aguarde...',
  'pt.relatorio.erro.gerar': 'Erro ao gerar relatório. Tente novamente.',
  'pt.relatorio.preview.titulo':    'Pré-visualização',
  'pt.relatorio.preview.registros': 'registros encontrados',
  'pt.relatorio.preview.vazio':     'Preencha algum filtro para pré-visualizar os dados',
  'pt.detalhe.titulo': 'Detalhamento de relatório de atividades',
  'pt.detalhe.btn.voltar': 'Voltar para listagem',
  'pt.detalhe.btn.gerando': 'Gerando...',
  'pt.detalhe.btn.imprimir': 'Imprimir',
  'pt.detalhe.label.codigo': 'Código',
  'pt.detalhe.label.emissao': 'Emissão',
  'pt.detalhe.label.status': 'Status',
  'pt.detalhe.label.servico': 'Serviço',
  'pt.detalhe.status.finalizado': 'Finalizado',
  'pt.detalhe.status.nao.finalizado': 'Não finalizado',
  'pt.detalhe.secao.dados.servico': 'Dados do serviço',
  'pt.detalhe.btn.ver.mapa': 'Ver mapa',
  'pt.detalhe.secao.equipe': 'Equipe',
  'pt.detalhe.secao.atividades': 'Atividades do dia',
  'pt.detalhe.label.inicio': 'Início:',
  'pt.detalhe.label.termino': 'Término:',
  'pt.detalhe.secao.observacoes': 'Observações',
  'pt.detalhe.mapa.titulo': 'Localização',
  'pt.detalhe.btn.fechar': 'Fechar',
  'pt.detalhe.label.evidencias': 'Evidências da operação',
  'pt.detalhe.relatorio.gerando': 'Gerando relatório...',
  'pt.detalhe.sem.respostas': 'Esta atividade não possui dados preenchidos.',
  'pt.detalhe.label.sem.localizacao': 'Sem localização',
  'pt.relatorio.titulo': 'Parâmetros do Relatório',
  'pt.relatorio.label.local': 'Local',
  'pt.relatorio.label.data.servico.de': 'Data de Serviço (de)',
  'pt.relatorio.label.data.servico.ate': 'Data de Serviço (até)',
  'pt.relatorio.label.tipo.servico': 'Tipo de Serviço',
  'pt.relatorio.label.solicitante': 'Solicitante',
  'pt.relatorio.label.supervisor': 'Supervisor',
  'pt.relatorio.label.participante': 'Participante',
  'pt.relatorio.label.tipo.atividade': 'Tipo de Atividade',
  'pt.relatorio.label.servico.finalizado': 'Serviço Finalizado',
  'pt.relatorio.btn.cancelar': 'Cancelar',
  'pt.relatorio.btn.excel': 'Excel',
  'pt.relatorio.btn.pdf': 'PDF',
  'campos.erro.buscar': 'Erro ao buscar dados',
  'campos.erro.editar': 'Erro ao editar Campo',
  'campos.erro.salvar': 'Erro ao salvar Campo',
  'campos.erro.excluir': 'Erro ao excluir Campo',
  'campos.erro.listar': 'Erro ao listar Campos',
  'campos.sucesso.editado': 'Campo editado com sucesso!',
  'campos.sucesso.salvo': 'Campo salvo com sucesso!',
  'campos.sucesso.excluido': 'Campo excluído com sucesso!',
  'campos.dialogo.excluir.titulo': 'Excluir Campo',
  'campos.tabela.id': 'Id',
  'campos.tabela.nome': 'Nome',
  'campos.tabela.sigla': 'Sigla',
  'campos.tabela.codigo.anp': 'Código ANP',
  'campos.tabela.nome.anp': 'Nome ANP',
  'campos.tabela.empresa': 'Empresa Relacionada',
  'campos.tabela.codigo.contrato': 'Código Contrato',
  'campos.tabela.cluster': 'Cluster',
  'campos.tabela.cromatografia': 'Cromatografia no Teste de Poço (dias)',
  'cluster.erro.consultar': 'Erro ao consultar Cluster para editar',
  'cluster.erro.editar': 'Erro ao editar Cluster',
  'cluster.erro.salvar': 'Erro ao salvar Cluster',
  'cluster.erro.excluir': 'Erro ao excluir Cluster',
  'cluster.erro.listar': 'Erro ao listar Clusters',
  'cluster.sucesso.editado': 'Cluster editado com sucesso!',
  'cluster.sucesso.salvo': 'Cluster salvo com sucesso!',
  'cluster.sucesso.excluido': 'Cluster excluído com sucesso!',
  'cluster.dialogo.excluir.titulo': 'Excluir Cluster',
  'cluster.tabela.id': 'Id',
  'cluster.tabela.nome': 'Nome',
  'home.erro.listar.aprs': 'Erro ao listar APRs',
  'home.erro.listar.pts': 'Erro ao listar Relatórios de Atividade',
  'input.dinamico.erro.listar.pessoa': 'Erro ao listar pessoa',
  'input.dinamico.erro.listar.fotos': 'Erro ao listar fotos do formulário',
  'export.erro.baixar.arquivo': 'Erro ao baixar arquivo',
  'export.sucesso.baixar.arquivo': 'Arquivo baixado com sucesso',
  'selector.erro.listar.dados': 'Erro ao listar dados, tente novamente',
  'arquivo.erro.tamanho.maximo': 'Tamanho máximo permitido para anexo é de {0} MB.',
  'arquivo.erro.nao.anexado': 'Arquivo não anexado',
  'arquivo.dialogo.excluir.titulo': 'Excluir Arquivo Atual do Sonolog',
  'arquivo.dialogo.excluir.mensagem': 'Tem certeza que deseja excluir? Você poderá adicionar outro arquivo.',
  'tabela.pesquisa': 'Pesquisa',
  'tabela.sucesso.arquivo.gerado': 'Arquivo gerado com sucesso.',
  'tabela.erro.gerar.arquivo': 'Erro ao gerar arquivo. Tente novamente.',
  'tabela.arquivo.gerando': 'Gerando arquivo...',
  'historico.tabela.propriedade': 'Propriedade',
  'historico.tabela.valor.antigo': 'Valor antigo',
  'historico.tabela.valor.novo': 'Valor novo',
  'historico.tabela.data': 'Data',
  'sidebar.dialogo.versoes.titulo': 'Versões Lançadas',
  'data.erro.intervalo': 'A data inicial deve ser anterior a data final',
  'data.erro.intervalo.titulo': 'Erro ao selecionar as datas',
  'tabela.pesquisar': 'Pesquisar',
  'tabela.limpar': 'Limpar',
  'tabela.coluna.acoes': 'Ações',
  'tabela.coluna.comentarios': 'Comentários',
  'tabela.sem.dados': 'Nenhum dado encontrado',
  'tabela.btn.importar': 'Importar',
  'tabela.btn.importar.indisponivel': 'Não existem medições para importar.',
  'tabela.btn.relatorio': 'Relatório',
  'tabela.btn.exportar': 'Exportar',
  'tabela.btn.exportar.excel': 'Excel',
  'tabela.btn.exportar.pdf': 'PDF',
  'tabela.btn.inserir': 'Inserir',
  'tabela.btn.visualizar': 'Visualizar',
  'tabela.btn.editar': 'Editar',
  'tabela.btn.deletar': 'Deletar',
  'tabela.btn.validar': 'Validar',
  'tabela.btn.outro': 'Outro',
  'tabela.btn.historico': 'Histórico de mudanças',
  'tabela.btn.informacoes': 'Informações',
  'tabela.btn.selecionar.todos': 'Selecionar Todos',
  'tabela.btn.remover.todos': 'Remover Todos',
  'tabela.btn.selecionar': 'Selecionar',
  'tabela.btn.remover': 'Remover',
  'tabela.info.criacao': 'Criação:',
  'tabela.info.alteracao': 'Alteração:',
  'tabela.info.validacao': 'Validação:',
  'tabela.info.encerramento': 'Encerramento:',
  'tabela.info.fers': 'FE&RS disponível:',
  'tabela.info.bsw': 'Bsw disponível:',
  'tabela.info.cromatografia': 'Cromatografia disponível:',
  'tabela.info.densidade': 'Densidade disponível:',
  'tabela.info.instrumento': 'Instrumentos disponíveis:',
  'tabela.paginacao.exibindo': 'Exibindo do',
  'tabela.paginacao.ao': 'ao',
  'tabela.paginacao.de': 'de',
  'tabela.paginacao.registros': 'registros',
  'tabela.paginacao.primeira': 'Primeira página',
  'tabela.paginacao.anterior': 'Página anterior',
  'tabela.paginacao.proxima': 'Próxima página',
  'tabela.paginacao.ultima': 'Última página',
  'tabela.filtro.limpar': 'Limpar filtros',
  'tabela.filtro.remover': 'Remover filtro',
  'tabela.filtro.filtrar': 'Filtrar',
  'home.filtro.label': 'Filtro',
  'home.metric.ra.emitidas': 'RA emitidas',
  'home.metric.media.atividade': 'Média de atividade',
  'home.metric.servicos.finalizados': 'Serviços finalizados',
  'home.metric.atividades.registradas': 'Atividades registradas',
  'home.metric.no.periodo': 'no período',
  'home.metric.por.ra': 'por RA',
  'home.metric.dos.relatorios': 'dos relatórios',
  'home.metric.total': 'total',
  'home.chart.tipo.servico': 'Tipo de serviço',
  'home.chart.tipo.atividade': 'Tipo de atividade',
  'home.mapa.titulo': 'Distribuição por local',
  'home.sem.dados': 'Sem dados no período',
  'home.erro.carregar.dados': 'Erro ao carregar dados do dashboard',
  'drf.selecione.periodo': 'Selecione um período',
  'drf.ate': 'até',
  'drf.periodo.label': 'Período',
  'drf.inicio': 'Início',
  'drf.fim': 'Fim',
  'drf.atalho.este-ano': 'Este ano',
  'drf.atalho.este-mes': 'Este mês',
  'drf.atalho.mes-passado': 'Mês passado',
  'drf.atalho.mes-retrasado': 'Mês retrasado',
  'drf.atalho.ultimos-30': 'Últimos 30 dias',
  'drf.atalho.essa-semana': 'Essa semana',
  'drf.atalho.personalizado': 'Selecionar período',
  'drf.label.data.servico': 'Filtro por data de serviço',
  'mapa.toggle.satelite': 'Satélite',
  'mapa.toggle.normal': 'Mapa',
  'mapa.popup.ver.ra': 'Ver RA',
  'galeria.fotos.baixando': 'Baixando arquivos...',
  'galeria.fotos.erro.baixar': 'Erro ao baixar os arquivos.',
  'galeria.sem.registro': 'Nenhum registro encontrado',
  'galeria.btn.baixar.todas': 'Baixar todas',
  'galeria.btn.baixar.foto': 'Baixar foto',
  'galeria.foto.alt': 'Foto',
};

export default messages;
